import React from 'react';
import {Warning} from '@mui/icons-material';
import {hoopsTheme} from '../../theme';

export function WarningIcon() {
  return <Warning style={{color: hoopsTheme.colors.palette.yellow}}/>;
}
